import { Pipe, PipeTransform } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { isEqual } from 'lodash-es';
import { IMap } from '@nimbus-library/features/shared/models/interfaces';
import { getIcuParameters } from '../../utils/utils';
import { PluralForm } from '../enums/pluralform.enum';
import { TranslationKeys } from '../enums/translation-keys.enum';

@Pipe({
  name: 'icuTranslate',
  pure: false,
  standalone: false,
})
export class IcuTranslatePipe extends TranslatePipe implements PipeTransform {
  public transform(query: TranslationKeys, pluralForm: PluralForm = PluralForm.One, placeholders: IMap<string> = {}, ...args: any[]): any {
    if (!query || !query.length) {
      return query;
    }

    // if we ask another time for the same key, return the last value
    if (isEqual(query, this.lastKey) && isEqual(args, this.lastParams)) {
      return this.value;
    }

    return super.transform(query, getIcuParameters(query, pluralForm, placeholders));
  }
}
